import React, { useState } from 'react';
import ContentTab from './ContentTab';
import StyleTab from './StyleTab';
import DataTab from './DataTab';
import LayoutTab from './LayoutTab';
import ContainerLayoutTab from './ContainerLayoutTab';

const PropertiesPanel = ({
    block,
    scanData,
    onToggle,
    onConfigUpdate,
    onStyleUpdate,
    onDataConfigUpdate,
    onRemove,
    onToggleEditMode,
    onUpdateCustomData,
    editingBlocks,
    dataContext,
    availableMetrics,
    pages,
    selectedElementPath,
    onResize,
    theme,
    scanGroups = [],
    allCategories = []
}) => {
    // Check if block is header or footer for layout tab
    const isHeaderFooter = block?.type === 'element' && (block?.elementType === 'header' || block?.elementType === 'footer');
    const isLayoutBlock = block?.type === 'section' || block?.type === 'row' || block?.type === 'column';
    
    const [activeTab, setActiveTab] = useState(isHeaderFooter ? 'layout' : (isLayoutBlock ? 'style' : 'content'));

    const updateConfig = (key, value) => {
        if (block) onConfigUpdate(block.id, { [key]: value });
    };

    const updateStyle = (key, value) => {
        if (block) onStyleUpdate(block.id, { [key]: value });
    };

    if (!block) return null;

    const blockLabel = (() => {
        const raw = block.widgetType || block.elementType || block.type || '';
        // Simple label overrides for common standard chart types
        const LABELS = {
            bar: 'Bar Chart', line: 'Line Chart', pie: 'Pie Chart', donut: 'Donut Chart',
            radar: 'Radar Chart', polar: 'Polar Area Chart', bubble: 'Bubble Chart',
            scatter: 'Scatter Plot', table: 'Table', numeric: 'Numeric', statcard: 'Stat Card',
            title: 'Title', text: 'Text', header: 'Header', footer: 'Footer',
            image: 'Image', shape: 'Shape', section: 'Section', row: 'Row', column: 'Column'
        };
        return LABELS[raw] || raw.replace(/-/g, ' ').replace(/\b\w/g, c => c.toUpperCase());
    })();

    return (
        <div className="properties-panel">
            <div className="properties-header">
                <h3 title={blockLabel}>{blockLabel} — Properties</h3>
                <button className="close-btn" onClick={onToggle}>
                    ✕
                </button>
            </div>

            <div className="properties-tabs">
            {!isHeaderFooter && !isLayoutBlock && (
                <button
                    className={`tab-btn ${activeTab === 'content' ? 'active' : ''}`}
                    onClick={() => setActiveTab('content')}
                >
                    Content
                </button>
            )}
            {isHeaderFooter && (
                <button
                    className={`tab-btn ${activeTab === 'layout' ? 'active' : ''}`}
                    onClick={() => setActiveTab('layout')}
                >
                    Layout
                </button>
            )}
            <button
                className={`tab-btn ${activeTab === 'style' ? 'active' : ''}`}
                onClick={() => setActiveTab('style')}
            >
                Style
            </button>
            {block.type === 'widget' && 
                block.widgetType !== 'infrastructure-scan-grid' && 
                block.widgetType !== 'managed-service-experience' && 
                block.widgetType !== 'security-scan-grid' &&
                block.widgetType !== 'cyber-security-threat-exposure' &&
                block.widgetType !== 'combined-scan-grid' &&
                block.widgetType !== 'advanced-scan-grid' &&
                block.widgetType !== 'single-finding-status' &&
                block.widgetType !== 'findings-status' && (
                <button
                    className={`tab-btn ${activeTab === 'data' ? 'active' : ''}`}
                    onClick={() => setActiveTab('data')}
                >
                    Data
                </button>
            )}
        </div>

        <div className="properties-content">
            {activeTab === 'content' && !isHeaderFooter && (
                <ContentTab
                    block={block}
                    updateConfig={updateConfig}
                    editingBlocks={editingBlocks}
                    onToggleEditMode={onToggleEditMode}
                    onUpdateCustomData={onUpdateCustomData}
                    dataContext={dataContext}
                    scanData={scanData}
                    pages={pages}
                    theme={theme}
                    scanGroups={scanGroups}
                    allCategories={allCategories}
                />
            )}

            {activeTab === 'layout' && isHeaderFooter && (
                <LayoutTab
                    block={block}
                    updateConfig={updateConfig}
                    pages={pages}
                    selectedElementPath={selectedElementPath}
                />
            )}

            {activeTab === 'style' && (
                <div className="property-group">
                    {isLayoutBlock ? (
                        <ContainerLayoutTab 
                            block={block} 
                            updateStyle={updateStyle} 
                        />
                    ) : (
                        <>
                            <h4>Typography & Colors</h4>
                            <StyleTab
                                block={block}
                                updateConfig={updateConfig}
                                updateStyle={updateStyle}
                                onResize={onResize}
                                dataContext={dataContext}
                                theme={theme}
                                globalVariables={[]} // Pass globalVariables if needed, or rely on context
                            />
                        </>
                    )}
                </div>
            )}

            {activeTab === 'data' && block.type === 'widget' && (
                <DataTab
                    block={block}
                    scanData={scanData}
                    dataContext={dataContext}
                    availableMetrics={availableMetrics}
                    onDataConfigUpdate={onDataConfigUpdate}
                    onConfigUpdate={onConfigUpdate}
                    pages={pages}
                />
            )}


        </div>

            <div className="properties-actions">
                <button
                    className="btn-danger"
                    onClick={() => onRemove(block.id)}
                >
                    Remove
                </button>
            </div>
        </div>
    );
};

export default PropertiesPanel;
